import { APIAddress } from "constants/config";
import updateTeacher from "./updateTeacher";

export default function archiveTeacher(teacherId) {

  if(!teacherId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing teacher Id (number)')
      })
    })
  }

  return updateTeacher(teacherId, {archived: true});
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/teacher/archiveTeacher.js